import CommonMixin from "./common-mixin";
export default {
    mixins: [CommonMixin],
    data() {
        return {
            dialogFormVisible: this.edit_mode,
            yellow_book: [],
            reference_book: [],
            contact_book: [],
            group_book: [],
            import_text: '',
            filter: '',
            group: {},
            reference_tabs: ['联系人', '通讯组'],
            tab_index: '联系人',
            debounced: null,
            panel_index:'0',
        }
    },
    props: {
        edit_mode: {
            type: Boolean,
            default() {
                return false;
            }
        },
        address_book: {
            type: Array,
            default() {
                return [];
            }
        },
    },
    filters: {
        noEmail(value) {
            if (typeof value === 'string') {
                return value.split('@')[0];
            } else
                return ''
        }

    },
    computed: {
        reference_filter() {
            let vm = this;
            return this.reference_book.filter(function (item) {
                return (item.email.indexOf(vm.filter) !== -1);
            })
        },
        contacts_filter() {
            let vm = this;
            // 需要将大小写考虑进去
            const filter = vm.filter.toLowerCase();
            return this.contact_book.filter(function (item) {
                let dept = item.department?item.department:'';
                let name = item.name?item.name:'';
                const lower_dept = dept.toLowerCase();
                const lower_name = name.toLowerCase();
                return (lower_dept.indexOf(filter) !== -1) || (lower_name.indexOf(filter) !== -1);
            })
        },
        group_filter() {
            let vm = this;
            const filter = vm.filter.toLowerCase();
            return this.group_book.filter(function (item) {
                return (item.name.toLowerCase().indexOf(filter) !== -1);
            });
        }
    },
    watch: {
        edit_mode: {
            handler(newVal) {
                this.dialogFormVisible = newVal;
            }
        },
        preset:{
            handler(newValue){
                if(newValue.app.yellow) {
                    this.reference_tabs.push('黄页');
                    this.getYellowBook();
                }
            },
            deep:true,
        }
    },
    methods: {
        handleTabClick(item) {
            this.tab_index = item.label;
        },
        handleClose(done) {
            done();
            this.$emit('cancel');
        },
        editSubmit() {
            this.$emit('success', this.address_book);
        },
        addToAddress() {
            const vm = this;
            if (this.tab_index === '联系人') {
                this.contact_book.forEach(item => {
                    if (item.select) {
                        item.select = false;
                        vm.addOneEmail(item);
                    }
                });
            } else if (this.tab_index === '黄页') {
                this.yellow_book.forEach(item => {
                    if (item.select) {
                        item.select = false;
                        vm.addOneEmail(item);
                    }
                });
            } else if (this.tab_index === '通讯组') {
                this.group_book.forEach(item => {
                    if (item.select) {
                        item.select = false;
                        if (item.email_array) {
                            item.email_array.forEach((item) => {
                                vm.addOneEmail(item);
                            });
                        }
                    } else {
                        if (item.email_array) {
                            item.email_array.forEach((item) => {
                                if (item.select)
                                    vm.addOneEmail(item);
                            });
                        }
                    }
                });
            }
            this.panel_index = '0';
        },
        clearAddressBook() {
            this.address_book.splice(0, this.address_book.length);
        },
        removeOneEmail(item) {
            const index = this.address_book.indexOf(item);
            if (index >= 0) this.address_book.splice(index, 1);
        },
        addOneEmail(item) {
            const vm = this;
            item.select = false;
            let found = false;
            vm.address_book.forEach(rec => {
                if (rec.email === item.email) {
                    found = true;
                }
            });
            if (!found) vm.address_book.push(item);
        },
        importEmails() {
            const raw1 = this.import_text.replace(/，/g, ',');
            const raw = raw1.replace(/;/g, ',').split(',');

            const vm = this;
            raw.forEach(function (item) {
                const regex = /[a-zA-Z0-9_-|.-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+/ig;
                if (item.match(regex)) {
                    const email = item.match(regex)[0];
                    const start = item.indexOf(email);
                    let name = item.substr(0, start).trim();
                    if (!name) {
                        name = email.split('@')[0];
                    }
                    let found = false;
                    if (name.substr(-1) === '<') name = name.substr(0,name.length-1);
                    vm.address_book.forEach(rec => {
                        if (rec.email === email) {
                            rec.name = name;
                            found = true;
                        }
                    });
                    if (!found) vm.address_book.push({name: name, email: email});
                }
            });

            this.import_text = '';
            this.panel_index = '0';

        },
        getContactBook() {
            this.$api('Query.Contacts', {}, 1).then(res => {
                this.contact_book = res.data.data;
            });
        },
        getGroupBook(){
            this.$api('Query.Groups', {}, 1).then(res => {
                this.group_book = res.data.data;
            });
        },
        getYellowBook(page) {
            const vm = this;
            if (!page) page = 1;
            this.$api('Query.Yellow', {query: this.filter, page: page}, 1).then(res => {
                vm.yellow_next = res.data.data.current_page < res.data.data.last_page ? (1 + res.data.data.current_page) : 0;
                if (page === 1) {
                    vm.yellow_book = [];
                    res.data.data.data.forEach(function (item) {
                        vm.yellow_book.push(Object.assign({}, {select: false}, item));
                    })
                } else {
                    res.data.data.data.forEach(function (item) {
                        vm.yellow_book.push(item);
                    });
                }
            });
        },
        loadYellowMore() {
            if (this.yellow_next !== 0) this.getYellowBook(this.yellow_next);
        },
        expendGroup(item) {
            this.$set(item, 'collapsed', !item.collapsed);
        },
        addGroupEmail(item) {
            const vm = this;
            item.select = false;
            if (item.email_array) {
                item.email_array.forEach((item) => {
                    vm.addOneEmail(item);
                });
            }
        },
        putEmailBack(item) {
            this.import_text = item.name + '<' + item.email + '>';
        },
        saveEmails() {
            const vm = this;
            if (vm.address_book.length) {
                vm.$affirm('将选中参会者保存到通讯录中?').then(function () {
                    vm.$api('User.SaveAddress',{'address':vm.address_book},1).then(function () {
                        //vm.$messageBox.success('参会者信息已保存到通讯录中!');
                    })
                });
            }
        }
    },
    mounted() {
        const vm=this;
        this.getGroupBook();
        this.getContactBook();
        if(this.preset && this.preset.app && this.preset.app.yellow) {
            this.reference_tabs.push('黄页');
            this.getYellowBook();
        }
        this.debounced = this.$debounce(1000, function () {
            vm.getYellowBook();
        });
    }
}
